import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

// Fills the edit form's tenant picker from a grouping; nothing is saved until the form is.
export default class extends Controller {
  static outlets = ["multiselect"];
  static targets = ["status"];
  static values = { url: String };

  // Bumped by clear() so a lookup still in flight can't refill a picker the user just emptied.
  lookupGeneration = 0;

  async add(event) {
    const { grouping, label } = event.params;
    const generation = this.lookupGeneration;
    this.statusTarget.textContent = `Finding ${label} tenants…`;

    let response;
    try {
      response = await get(this.urlValue, {
        query: { grouping },
        responseKind: "json",
      });
    } catch {
      response = null;
    }
    if (generation !== this.lookupGeneration) return;
    if (!response?.ok) {
      this.statusTarget.textContent = `Couldn't load ${label} tenants. Try again.`;
      return;
    }

    const { tenant_ids: tenantIds, skipped } = await response.json;
    if (generation !== this.lookupGeneration) return;
    const selected = new Set(
      this.multiselectOutlet.getSelectedValues().map(String),
    );
    const added = tenantIds.filter((id) => !selected.has(id));
    this.multiselectOutlet.setSelectedValues([...selected, ...added]);

    let message = `Added ${added.length} tenants. Save to apply.`;
    if (skipped.length > 0)
      message += ` Skipped tenants whose POS couldn't be checked: ${skipped.join(", ")}.`;
    this.statusTarget.textContent = message;
  }

  clear() {
    this.lookupGeneration += 1;
    this.multiselectOutlet.clearSelections();
    this.statusTarget.textContent = "Cleared all tenants. Save to apply.";
  }
}
